// Marker for an active browser login session; wiped on browser close.
export const BROWSER_SESSION_KEY = 'nx-los-session';

// Written on login to evict other tabs.
export const LOGIN_SIGNAL_KEY = 'nx-los-login-signal';
